let prefix = `/slope_types`

export default {
    getAll: () => axios.get(`${prefix}`),
}
